// extracted by mini-css-extract-plugin
export var wordContainer = "_hm-0";